/* eslint-disable */
export class AuctionManager {
    static AUCTION_DURATION = 3 // Auctions last 3 game days
    
    static calculateBaseValue(chocobo) {
      // Ensure chocobo has all required properties
      const speed = chocobo.speed || 0
      const stamina = chocobo.stamina || 0
      const level = chocobo.level || 1
      const improvementFactor = chocobo.behavior?.improvement_factor || 5 // Default to 5 if no behavior
      
      const baseValue = (
        (speed * 100) +
        (stamina * 100) +
        (level * 1000) +
        (improvementFactor * 2000)
      )
  
      // Bonuses for special attributes
      const xFactorBonus = (
        (chocobo.hasSpeedXFactor ? 10000 : 0) +
        (chocobo.hasStaminaXFactor ? 10000 : 0)
      )
  
      // Color rarity bonus
      const colorBonus = {
        yellow: 0,
        blue: 5000,
        green: 5000,
        black: 10000,
        pink: 15000,
        gold: 25000
      }[chocobo.color] || 0
  
      return baseValue + xFactorBonus + colorBonus
    }
  
    static generateBids(chocobo, potentialBuyers, gameStore) {
      const baseValue = this.calculateBaseValue(chocobo)
      
      return potentialBuyers
        .filter(buyer => {
          const analysis = OwnerFinancialManager.analyzeFinancialPosition(buyer, gameStore)
          return buyer.money >= baseValue && analysis.hasExcessFunds
        })
        .map(buyer => {
          const willingnessFactor = (
            (buyer.ambition * 0.4) +
            (buyer.competitiveness * 0.4) +
            (buyer.shrewdness * -0.2)
          ) / 100
  
          const baseMultiplier = 1 + willingnessFactor
          const randomVariation = 0.9 + (Math.random() * 0.2) // ±10% random variation
  
          const bidAmount = Math.round(baseValue * baseMultiplier * randomVariation)
  
          return {
            ownerId: buyer.id,
            amount: bidAmount
          }
        })
        .filter(bid => bid.amount >= baseValue * 0.9) // Only include reasonable bids
        .sort((a, b) => b.amount - a.amount) // Sort by highest bid
    }
  
    static handleSale(chocobo, buyer, seller, price, gameStore) {
        // Verify buyer has enough money
        if (buyer.money < price) {
          return { 
            success: false, 
            reason: 'Insufficient funds' 
          }
        }
      
        // Transfer money from buyer to seller
        buyer.money -= price
        seller.money += price
        
        // Transfer chocobo ownership
        seller.chocoboIds = seller.chocoboIds.filter(id => id !== chocobo.id)
        buyer.chocoboIds.push(chocobo.id)
      
        return {
          success: true,
          transaction: {
            chocobo,
            buyer,
            seller,
            price
          }
        }
      }      
  }